module.exports = __webpack_public_path__ + "img/hero.ce2441a.jpg";